import { Link } from "react-router-dom";

const Unauthorized = () => (
	<div className="w-full h-full flex flex-col justify-center items-center text-center bg-elevated-0 text-white gap-4">
		<strong>No Access</strong>
		<div className="flex flex-col gap-1">
			<p>
				Sorry, you don't have access to this page. Please contact your administrator for assistance.
			</p>
			<p>
				You can return to the{" "}
				<Link to="/" className="font-bold">
					homepage
				</Link>
			</p>
		</div>
		<p>Thank you for your patience.</p>
	</div>
);

export default Unauthorized;
